import React from 'react'
import FeatureDocumentation from '../../components/layouts/docsection';
import Resellers from "../../images/reseller.png"
 
const Reseller = () => {
  const ResellerDoc = {
    title: "Reseller Management",
    description: "This documentation provides a comprehensive guide on how to manage resellers efficiently within our system. It covers all aspects of reseller management, from viewing and editing their information to understanding their performance metrics.",
    sections: [
      {
        title: "Overview",
        content:
          "In this section, you will find a detailed list of all registered resellers, allowing you to view key metrics and manage their data effectively. This interface is designed to provide a snapshot of reseller activity at a glance, making it easy to monitor their performance and interactions within the platform."
      },
      {
        title: "Reseller Management",
        content:
          "Each reseller is associated with a set of controls that facilitate the management of their accounts. These controls include options to view user details, edit shop information, delete users, and manage referrals.",
        image: Resellers,
        imageAlt: "Reseller Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Reseller Dashboard.",
        subsections: [
          {
            title: "Reseller Actions",
            content:
              "This section provides a brief overview of the actions that can be performed for each reseller. These actions help streamline the management process and ensure that reseller data is current and accurate.",
            steps: [
              "1. Search Functionality: Utilize the search button to locate specific orders by their order number. For example, you can enter '1724842874791' while omitting the 'ORDERGH-' prefix to yield the best results.",
              "2. VIEW USER: This option displays detailed information about the reseller, including personal details and a comprehensive list of items they have resold. This helps in assessing their performance and understanding their sales history.",
              "3. EDIT SHOP: This functionality allows you to modify the name of the reseller's shop. Additionally, there is a toggle feature that indicates whether the reseller is classified as a brand or an influencer, providing clarity on their market positioning.",
              "4. DELETE USER: Currently, this option is disabled to prevent accidental removal of reseller accounts. This functionality may be enabled in future updates to enhance account management.",
              "5. REFERRALS: Similar to the delete user option, the referral management feature is also currently disabled. Future updates may introduce additional capabilities in this area."
            ]
          }
        ]
      }
    ]
  };
  
  return (
    <FeatureDocumentation {...ResellerDoc}/>
  )
}

export default Reseller;

